import { render } from "./ContextMenuSub.vue?vue&type=template&id=dc1b4cda"
import script from "./ContextMenuSub.vue?vue&type=script&lang=js"
export * from "./ContextMenuSub.vue?vue&type=script&lang=js"
script.render = render

export default script